export enum BufferUnit {
  metres = 0,
  feet = 1,
  kilometres = 2,
  miles = 3,
}
